// NPM MODULES
import { FormHelperText, MenuItem, Select, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';

// NETWORK
import useLanguageRequest from '../../requests/LanguageRequest';

const LanguagePicker = ({
  onChange,
  returnDefaultLanguageId,
  selectName = 'language_id',
  selectedLanguageId,
  selectDefault,
  errorHandler,
  error = false,
  required = false,
  helperText,
  value,
  label,
}) => {
  const [languages, setLanguages] = useState([]);
  const { getLanguages } = useLanguageRequest();

  useEffect(() => {
    const fetchLanguages = async () => {
      let fetchedLanguages = await getLanguages(errorHandler);

      if (returnDefaultLanguageId || selectedLanguageId) {
        fetchedLanguages = fetchedLanguages.filter(
          (language) => language.language_name.toLowerCase() !== 'universal'
        );

        if (returnDefaultLanguageId) {
          const defaultLanguage = fetchedLanguages.find(
            (language) => language.language_name.toLowerCase() === 'english'
          );
          if (defaultLanguage) {
            returnDefaultLanguageId(defaultLanguage.language_id);
          }
        }
      }

      setLanguages(fetchedLanguages);
    };

    fetchLanguages();
  }, []);

  // Use value prop if provided, otherwise fall back to selectedLanguageId
  const currentValue = value || selectedLanguageId || '';

  return (
    <>
      {languages.length > 0 && (
        <Stack spacing={1} width="100%">
          <Select
            label={label}
            size="small"
            fullWidth
            name={selectName}
            value={currentValue}
            onChange={(e) => onChange && onChange(e.target.value)}
            displayEmpty
            error={error}
            required={required}
          >
            {selectDefault && (
              <MenuItem value="" disabled>
                Select One
              </MenuItem>
            )}
            {languages.map((language) => (
              <MenuItem key={language.language_id} value={language.language_id}>
                {language.language_name}
              </MenuItem>
            ))}
          </Select>
          {helperText && (
            <FormHelperText sx={{ color: 'error.main', paddingLeft: 2 }}>
              {helperText}
            </FormHelperText>
          )}
        </Stack>
      )}
    </>
  );
};

export default LanguagePicker;
